import { Injectable, Inject } from '@angular/core';
import { NenkanScheduleMasterDto, Szza024aRequest, SZZA024AService } from "sg-api";
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { SgkbConstains } from '../sg-kb-constans';

/**
 * 年間スケジュールマスタ照会API使用サービス
 * @export
 * @class UsedSzza024aService
 */
@Injectable({
  providedIn: 'root'
})
export class UsedSzza024aService {
  /**年間スケジュールマスタ照会結果のSubject */
  private _nenkanscheduleMasterResult$: BehaviorSubject<Array<NenkanScheduleMasterDto>> = new BehaviorSubject<Array<NenkanScheduleMasterDto>>([]);

  /**
   * コンストラクタ
   * @param {SZZA024AService} sZZA024AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @memberof UsedSzza024aService
   */
  constructor(
    private sZZA024AService: SZZA024AService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 年間スケジュールマスタ照会結果のobservable提供
   * @readonly
   * @memberof UsedSzza024aService
   */
  get nenkanscheduleValueChanges() {
    return this._nenkanscheduleMasterResult$.asObservable();
  }

  /**
 * 年間スケジュールマスタ照会API呼び出し
 * @param {*} value
 * @return {*}  {Observable<Array<NenkanScheduleMasterDto>>}
 * @memberof UsedSzza024aService
 */
  searchNenkanSchedule(szza024aRequest: Szza024aRequest): Observable<Array<NenkanScheduleMasterDto>> {
    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(szza024aRequest, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    // 検索条件を保存
    return this.sZZA024AService.a10RSZZA024APost(<Szza024aRequest>this.apiCommonService.setRequestCommon(szza024aRequest), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._nenkanscheduleMasterResult$.next(response.body.nenkanSchdlMasterSrchResultList);
          return response.body.nenkanSchdlMasterSrchResultList;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SYS,
            SgkbConstains.MESSAGE.APINAME_SZZA024A);
          return throwError(err.message);
        })
      );
  }
}
